/**
 * Small offline fallback bank if Grok is unavailable.
 * Questions are general family-safe; still prefer Grok for age-tuned sets.
 */
import { QUESTION_COUNT } from "./millionaireConstants";

const BANK = [
  {
    n: 1,
    prompt: "How many legs does a typical dog have?",
    choices: ["Two", "Four", "Six", "Eight"],
    correctIndex: 1,
    category: "animals",
    explanation: "Dogs are four-legged mammals."
  },
  {
    n: 2,
    prompt: "What color do you get when you mix blue and yellow paint?",
    choices: ["Purple", "Orange", "Green", "Brown"],
    correctIndex: 2,
    category: "art",
    explanation: "Blue and yellow make green."
  },
  {
    n: 3,
    prompt: "Which planet do we live on?",
    choices: ["Mars", "Earth", "Venus", "Jupiter"],
    correctIndex: 1,
    category: "science",
    explanation: "Earth is our home planet."
  },
  {
    n: 4,
    prompt: "How many days are in a week?",
    choices: ["Five", "Six", "Seven", "Ten"],
    correctIndex: 2,
    category: "everyday",
    explanation: "A week has seven days."
  },
  {
    n: 5,
    prompt: "What do bees make?",
    choices: ["Milk", "Honey", "Butter", "Cheese"],
    correctIndex: 1,
    category: "nature",
    explanation: "Bees produce honey."
  },
  {
    n: 6,
    prompt: "Which ocean is the largest?",
    choices: ["Atlantic", "Indian", "Arctic", "Pacific"],
    correctIndex: 3,
    category: "geography",
    explanation: "The Pacific is the largest ocean."
  },
  {
    n: 7,
    prompt: "What gas do plants absorb that humans exhale?",
    choices: ["Oxygen", "Nitrogen", "Carbon dioxide", "Helium"],
    correctIndex: 2,
    category: "science",
    explanation: "Plants use carbon dioxide in photosynthesis."
  },
  {
    n: 8,
    prompt: "How many sides does a hexagon have?",
    choices: ["Five", "Six", "Seven", "Eight"],
    correctIndex: 1,
    category: "math",
    explanation: "Hex means six."
  },
  {
    n: 9,
    prompt: "Which instrument has 88 keys?",
    choices: ["Guitar", "Flute", "Piano", "Drum"],
    correctIndex: 2,
    category: "music",
    explanation: "A standard piano has 88 keys."
  },
  {
    n: 10,
    prompt: "What is the capital of France?",
    choices: ["Lyon", "Paris", "Marseille", "Nice"],
    correctIndex: 1,
    category: "geography",
    explanation: "Paris is the capital of France."
  },
  {
    n: 11,
    prompt: "Who wrote the play Romeo and Juliet?",
    choices: ["Charles Dickens", "William Shakespeare", "Jane Austen", "Mark Twain"],
    correctIndex: 1,
    category: "literature",
    explanation: "Shakespeare wrote Romeo and Juliet."
  },
  {
    n: 12,
    prompt: "What is H2O more commonly known as?",
    choices: ["Salt", "Water", "Sugar", "Air"],
    correctIndex: 1,
    category: "science",
    explanation: "H2O is the chemical formula for water."
  },
  {
    n: 13,
    prompt: "In which sport is a shuttlecock used?",
    choices: ["Tennis", "Badminton", "Golf", "Hockey"],
    correctIndex: 1,
    category: "sports",
    explanation: "Badminton is played with a shuttlecock."
  },
  {
    n: 14,
    prompt: "What is the largest mammal on Earth?",
    choices: ["African elephant", "Blue whale", "Giraffe", "Hippopotamus"],
    correctIndex: 1,
    category: "animals",
    explanation: "The blue whale is the largest animal."
  },
  {
    n: 15,
    prompt: "How many degrees are in a right angle?",
    choices: ["45", "60", "90", "180"],
    correctIndex: 2,
    category: "math",
    explanation: "A right angle measures 90 degrees."
  }
];

/**
 * @returns {typeof BANK}
 */
export function getFallbackQuestions() {
  return BANK.slice(0, QUESTION_COUNT).map((q) => ({
    ...q,
    choices: [...q.choices]
  }));
}
